<div id="casino-tiles-container" class="casino-tiles-container">
    <div class="top-description-container">
        <ng-content select="[slot=top-left]" />
    </div>
    <vn-swiper #tilesContentHost [swiperOptions]="swiperOptions()" [showPagination]="true">
        <ng-content />
    </vn-swiper>
</div>
